export class DocumentUtils {
	public static clean(value?: string): string {
		if (!value) return '';
		return value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
	}

	public static isCnpjValid(value?: string): boolean {
		const cnpj = DocumentUtils.clean(value);

		if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false;
		if (/^(.)\1{13}$/.test(cnpj)) return false;

		const toNumber = (char: string) => char.charCodeAt(0) - 48;

		const calcDigit = (length: number): number => {
			let sum = 0;
			let factor = length - 7;

			for (let i = 0; i < length; i++) {
				sum += toNumber(cnpj[i]) * factor;
				factor = factor - 1 < 2 ? 9 : factor - 1;
			}

			const result = sum % 11;
			return result < 2 ? 0 : 11 - result;
		};

		const firstDigit = calcDigit(12);
		if (firstDigit !== parseInt(cnpj[12], 10)) return false;

		const secondDigit = calcDigit(13);
		return secondDigit === parseInt(cnpj[13], 10);
	}

	/**
	 * Decide se o documento limpo representa um CNPJ.
	 * CNPJ sempre tem 14 caracteres (e pode conter letras); CPF tem 11 dígitos.
	 */
	public static isCnpj(value?: string): boolean {
		const clean = DocumentUtils.clean(value);
		return /[A-Z]/.test(clean) || clean.length > 11;
	}

	public static formatCnpj(value?: string): string {
		const clean = DocumentUtils.clean(value).slice(0, 14);
		if (clean.length < 3) return clean;
		if (clean.length < 6)
			return `${clean.slice(0, 2)}.${clean.slice(2, 5)}`;
		if (clean.length < 9)
			return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}`;
		if (clean.length < 13)
			return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(
				5,
				8,
			)}/${clean.slice(8, 12)}`;
		return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(
			5,
			8,
		)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
	}
}

export const cleanDocument = (value?: string): string =>
	DocumentUtils.clean(value);
